import { useLang } from "@/context/LangContext";
import { Instagram } from "lucide-react";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0F3D2E] text-[#FAF7F0] pt-24 pb-12 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-5 flex flex-col items-center text-center">
            <img
              src="/logos/pakla_logo_clean.png"
              alt="PAKLA"
              className="w-32 md:w-40 lg:w-44 h-auto object-contain mb-6"
              style={{ filter: "brightness(0) invert(1)" }}
              draggable="false"
            />
            <p className="mt-2 text-[14px] leading-relaxed text-[#FAF7F0]/70 max-w-md">
              {t.footer.tagline}
            </p>
          </div>

          <div className="col-span-6 md:col-span-3 md:col-start-7">
            <div className="text-[11px] tracking-[0.24em] uppercase text-[#2E8B4A] mb-4">Şirket</div>
            <div className="text-[13px] text-[#FAF7F0]/85 leading-relaxed">
              {t.footer.company}
              <br /><br />
              {t.footer.address}
            </div>
          </div>

          <div className="col-span-6 md:col-span-2 md:col-start-11">
            <div className="text-[11px] tracking-[0.24em] uppercase text-[#2E8B4A] mb-4">İletişim</div>
            <div className="text-[13px] text-[#FAF7F0]/85 space-y-2">
              <a href="mailto:info@pakla.net" className="block hover:text-[#FAF7F0]">
                {t.footer.email}
              </a>
              <a href="tel:+908504419796" className="block hover:text-[#FAF7F0]">
                {t.footer.phone}
              </a>
              <a href="https://www.pakla.net" className="block hover:text-[#FAF7F0]">
                www.pakla.net
              </a>
              <a
                href="https://www.instagram.com/pakla_anatekkimya/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="inline-flex items-center gap-2 mt-3 hover:text-[#FAF7F0]"
                aria-label="Instagram"
              >
                <Instagram size={18} strokeWidth={1.6} />
                <span>@pakla_anatekkimya</span>
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-[#FAF7F0]/15 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="text-[11px] tracking-[0.2em] uppercase text-[#FAF7F0]/50">
            © {new Date().getFullYear()} PAKLA · {t.footer.rights}
          </div>
          <div className="text-[11px] tracking-[0.2em] uppercase text-[#FAF7F0]/50">
            Doğal · Saf · Temiz
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
